export default __webpack_public_path__ + "static/media/smashingmagazine.c0aa6060.svg";